import { forwardRef, type SVGProps } from "react";

/**
 * Branded shield mark used in the header, footer, and other surfaces
 * carrying the nLPD Conform identity. Replaces the generic lucide `Shield`.
 *
 * Inherits color via `currentColor` — set the surrounding text color
 * (e.g. `text-primary`) and the shield body picks it up. The check stroke
 * is always white so it reads on any brand-color background.
 */
export const BrandLogo = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function BrandLogo({ className, ...props }, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className={className}
        {...props}
      >
        <defs>
          <linearGradient id="brand-logo-grad" x1="16" y1="2" x2="16" y2="30" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="currentColor" stopOpacity="1" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0.82" />
          </linearGradient>
        </defs>
        <path
          d="M16 2.6 5.6 6.1a1.6 1.6 0 0 0-1.1 1.5v6.7c0 7 4.5 12.4 11 14.9.3.1.7.1 1 0 6.5-2.5 11-7.9 11-14.9V7.6a1.6 1.6 0 0 0-1.1-1.5L16 2.6Z"
          fill="url(#brand-logo-grad)"
        />
        <path
          d="M10.8 16.4 14.4 20l6.8-7.4"
          stroke="#ffffff"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
